interface StatisticsCardProps {
    label: string;
    value: number | string;
}

const StatisticsCard = ({ label, value }: StatisticsCardProps) => (
    <div className="flex flex-col gap-1">
        <span className="text-sm text-on-surface/60 font-semibold">{label}</span>
        <span className="text-[40px] font-bold text-on-surface tracking-tight">{value}</span>
    </div>
);

export default StatisticsCard;
